.bodyContainer {
  display: flex;
  flex-direction: column;
}

.bodyContainer--fullViewportHeight {
  min-height: 100dvh;
  padding-bottom: 40px;
}

@media all and (--reefer-media-tablet-min) {
  .layoutPadding {
    padding-bottom: 80px;
  }
}
